/**
 * Abgleich zwischen mehreren offenen Fenstern derselben Geschichte: Nach jeder bestätigten Änderung meldet ein Fenster das über einen
 * BroadcastChannel, die anderen laden die Geschichte neu. Ungespeicherte Entwürfe bleiben dabei stehen (siehe DraftSaver); ein Text,
 * der so unter einem Entwurf geändert wurde, erscheint als Konflikt statt überschrieben zu werden.
 */

const CHANNEL = 'dispositio.story';

let channel: BroadcastChannel | null | undefined;
const getChannel = (): BroadcastChannel | null => {
  if (channel === undefined) {
    try {
      channel = typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL);
    } catch {
      channel = null;
    }
  }
  return channel;
};

/** Dieses Fenster hat die Geschichte geändert */
export function announceChange(projectId: string): void {
  try {
    getChannel()?.postMessage({ projectId });
  } catch {
    // ohne Kanal kein Abgleich
  }
}

/** Ein anderes Fenster hat eine Geschichte geändert (`fn` bekommt ihre ID); liefert die Abmeldung. */
export function onRemoteChange(fn: (projectId: string) => void): () => void {
  const ch = getChannel();
  if (!ch) return () => undefined;
  const listener = (e: MessageEvent): void => {
    const id = (e.data as { projectId?: unknown } | null)?.projectId;
    if (typeof id === 'string') fn(id);
  };
  ch.addEventListener('message', listener);
  return () => ch.removeEventListener('message', listener);
}
